<template>
    <div class="headermenu">
        <!-- <div class="py-0 px-0 container">
            <div class="menubar justify-end">
                <div class="d-flex align-center right-icons">
                    <div v-for="(menu, i) in $optional('data.logobar_menu?.labels')" :key="i" class="icon-item">
                        <v-tooltip attach bottom transition="slide-y-transition">
                            <template v-slot:activator="{ on, attrs }">
                                <router-link :to="$optional('data.logobar_menu.links')[i]" class="text-reset">
                                    <i class="las" v-bind="attrs" v-on="on" v-bind:class="$optional('data.logobar_menu.icons')[i]">
                                        <v-badge
                                            color="error"
                                            :content="getCartCount"
                                            inline
                                            v-if="getCartCount > 0 && $optional('data.logobar_menu.links')[i] === '/cart'"
                                            class="icon-badge"
                                            style="left: 1325px; top: -12px"
                                        ></v-badge>
                                    </i>
                                </router-link>
                            </template>
                            <span>{{ menu }}</span>
                        </v-tooltip>
                    </div>

                    <div v-if="!isAuthenticated" class="icon-item">
                        <v-tooltip attach bottom transition="slide-y-transition">
                            <template v-slot:activator="{ on, attrs }">
                                <router-link :to="{ name: 'Login' }" class="text-reset">
                                    <i v-bind="attrs" v-on="on" class="las la-sign-in-alt"></i>
                                </router-link>
                            </template>
                            <span>로그인</span>
                        </v-tooltip>
                    </div>
                    <div v-else class="icon-item">
                        <v-tooltip attach bottom transition="slide-y-transition">
                            <template v-slot:activator="{ on, attrs }">
                                <router-link :to="{ name: 'Logout' }" class="text-reset">
                                    <i v-bind="attrs" v-on="on" class="las la-sign-out-alt"></i>
                                </router-link>
                            </template>
                            <span>로그아웃</span>
                        </v-tooltip>
                    </div>
                </div>
            </div>
        </div> -->
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        props: {
            loading: { type: Boolean, required: true, default: true },
            data: {
                type: Object,
                default: {},
                current_path: '',
            },
        },
        computed: {
            ...mapGetters('cart', ['getCartCount']),
            ...mapGetters('auth', ['isAuthenticated']),
        },
    };
</script>
<style lang="scss" scoped>
    .headermenu {
        position: relative;
        height: 64px;
    }

    .headermenu {
        .menubar {
            display: flex;
            height: 63px;
        }
    }

    /* 오른쪽 아이콘 스타일 */
    .right-icons {
        margin-top: -2px;
        margin-right: -4px;
    }
    .icon-item a {
        font-size: 2rem;
        line-height: 1;
        display: block;
        text-align: center;
        margin: 0 4px;
        padding: 4px;
    }
    .icon-badge {
        position: absolute;
        top: -20px;
        right: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 100;
    }
</style>
